
// import publicAxiosClient from '../publicAxiosClient';

// export const dispatchApi = {
//   getDispatchDetails: async (docEntry, docNum, refNo) => {
//     try {
//       const params = new URLSearchParams({ docEntry, docNum });
//       if (refNo) params.append('refNo', refNo);
//       const data = await publicAxiosClient.get(`/dispatch/details?${params.toString()}`);
//       return data;
//     } catch (error) {
//       console.error('Error fetching dispatch details:', error);
//       throw error;
//     }
//   },

//   checkPdf: async (docNum) => {
//     try {
//       const data = await publicAxiosClient.get(`/invoice/check-pdf/${docNum}`);
//       return data; // { docNum, exists: true/false }
//     } catch (error) {
//       console.error('Error checking PDF:', error);
//       return { exists: false };
//     }
//   },

//   downloadPdf: async (docNum, invoiceNo) => {
//     try {
//       // Use fetch directly since we need blob response, not JSON
//       const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';
//       const response = await fetch(`${API_URL}/api/invoice/download-pdf/${docNum}`, {
//         method: 'GET',
//       });

//       if (!response.ok) throw new Error('Failed to download PDF');

//       const blob = await response.blob();
//       const url = URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = `Invoice_${invoiceNo || docNum}.pdf`;
//       document.body.appendChild(a);
//       a.click();
//       setTimeout(() => {
//         document.body.removeChild(a);
//         URL.revokeObjectURL(url);
//       }, 100);

//     } catch (error) {
//       console.error('Error downloading PDF:', error);
//       throw error;
//     }
//   },
// };


import publicAxiosClient from '../publicAxiosClient';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const downloadBlob = async (url, filename) => {
  const response = await fetch(url);
  if (!response.ok) throw new Error('Download failed');
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(objectUrl); }, 100);
};

export const dispatchApi = {
  getDispatchDetails: async (docEntry, docNum, refNo) => {
    try {
      const params = new URLSearchParams({ docEntry, docNum });
      if (refNo) params.append('refNo', refNo);
      return await publicAxiosClient.get(`/dispatch/details?${params.toString()}`);
    } catch (error) {
      console.error('Error fetching dispatch details:', error);
      throw error;
    }
  },

  checkPdf: async (docNum) => {
    try {
      return await publicAxiosClient.get(`/invoice/check-pdf/${docNum}`);
    } catch {
      return { exists: false };
    }
  },

  downloadPdf: async (docNum, invoiceNo) => {
    try {
      await downloadBlob(
        `${API_URL}/api/invoice/download-pdf/${docNum}`,
        `Invoice_${invoiceNo || docNum}.pdf`
      );
    } catch (error) {
      console.error('Error downloading PDF:', error);
      throw error;
    }
  },

  // NEW: Download density COA (LOCAL source)
  downloadDensityCoa: async (itemCode, batchNumber) => {
    await downloadBlob(
      `${API_URL}/api/density-coa/download-by-item/${encodeURIComponent(itemCode)}/${encodeURIComponent(batchNumber)}`,
      `COA_${itemCode}_${batchNumber}.pdf`
    );
  },

  // NEW: Download energy COA (ENERGY source)
  downloadEnergyCoa: async (itemCode, batchNumber) => {
    await downloadBlob(
      `${API_URL}/api/coa/download-energy/${encodeURIComponent(itemCode)}/${encodeURIComponent(batchNumber)}`,
      `COA_${itemCode}_${batchNumber}.pdf`
    );
  },
};